import { render, staticRenderFns } from "./ServiceIndex.vue?vue&type=template&id=b82eb514&"
import script from "./ServiceIndex.vue?vue&type=script&lang=js&"
export * from "./ServiceIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports